import React from 'react';
import Icon from '../../../components/AppIcon';


const EquipmentStatusCard = ({ machine, onStatusUpdate, onSelect }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'operational':
        return 'bg-green-100 text-green-800';
      case 'maintenance':
        return 'bg-yellow-100 text-yellow-800';
      case 'offline':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'operational':
        return 'CheckCircle';
      case 'maintenance':
        return 'Tool';
      case 'offline':
        return 'XCircle';
      default:
        return 'Circle';
    }
  };

  const utilizationPercentage = machine?.productionCapacity > 0
    ? ((machine?.currentUtilization / machine?.productionCapacity) * 100)?.toFixed(0)
    : 0;

  return (
    <div className="bg-gray-50 rounded-lg p-4 hover:bg-gray-100 transition-colors cursor-pointer" onClick={onSelect}>
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <h3 className="font-semibold text-gray-900">{machine?.machineName}</h3>
          <p className="text-xs text-gray-500">{machine?.machineCode}</p>
        </div>
        <span className={`text-xs px-2 py-1 rounded-full ${getStatusColor(machine?.status)}`}>
          {machine?.status}
        </span>
      </div>
      <div className="space-y-2">
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-600">Modèle:</span>
          <span className="font-medium text-gray-900">{machine?.model}</span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-600">Localisation:</span>
          <span className="font-medium text-gray-900">{machine?.location}</span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-600">Heures Opération:</span>
          <span className="font-medium text-gray-900">{machine?.operatingHours || 0}h</span>
        </div>
      </div>
      {/* Utilization Bar */}
      <div className="mt-3">
        <div className="flex items-center justify-between text-xs text-gray-600 mb-1">
          <span>Utilisation</span>
          <span className="font-medium">{utilizationPercentage}%</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2">
          <div
            className="bg-blue-600 h-2 rounded-full transition-all"
            style={{ width: `${Math.min(utilizationPercentage, 100)}%` }}
          />
        </div>
      </div>
      {/* Maintenance Info */}
      {machine?.nextMaintenanceDate && (
        <div className="mt-3 pt-3 border-t border-gray-200">
          <div className="flex items-center gap-2 text-xs text-gray-600">
            <Icon name="Calendar" size={14} />
            <span>Prochaine maintenance: {new Date(machine?.nextMaintenanceDate)?.toLocaleDateString('fr-FR')}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default EquipmentStatusCard;